import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Stack
} from '@mui/material';

const SubscriptionDialog = ({ open, onClose, modelName, onSubscribe, onSelectAlternative }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Premium Feature</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            {modelName ? `The model "${modelName}" requires` : 'This feature requires'} an active subscription to use.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Upgrade your plan to access premium features and advanced AI models.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={1} sx={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button 
            onClick={() => onSelectAlternative('gpt-4o-mini')} 
            variant="outlined" 
            color="primary"
          >
            Use GPT-4o-mini Instead
          </Button>
          <Button onClick={onSubscribe} variant="contained" color="primary">
            View Plans
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionDialog; 